import { setUrlFromState } from "../helpers/setUrlFromState";
import { Data } from "../types/Data";
import { State } from "../types/State";
import { GroupLabel } from "./GroupLabel";
import { Store } from "./Store";

export class PriceInput {
  store: Store;
  data: Data;
  label: GroupLabel;
  minPriceLabel: HTMLElement;
  minPriceInput: HTMLInputElement;
  maxPriceLabel: HTMLElement;
  maxPriceInput: HTMLInputElement;

  constructor({
    store,
    data,
    label,
  }: {
    store: Store;
    data: Data;
    label: GroupLabel;
  }) {
    this.store = store;
    this.data = data;
    this.label = label;
    this.minPriceLabel = document.getElementById(
      "min-value-price"
    )! as HTMLElement;
    this.minPriceInput = document.getElementById(
      "min-price"
    )! as HTMLInputElement;
    this.maxPriceLabel = document.getElementById(
      "max-value-price"
    )! as HTMLElement;
    this.maxPriceInput = document.getElementById(
      "max-price"
    )! as HTMLInputElement;
    this.#initValue();
    this.#registerOnChange();
    this.#renderLabel();
  }

  #initValue() {
    this.minPriceInput.value = this.store.getState()["prix-min"] || "0";
    this.maxPriceInput.value = this.store.getState()["prix-max"] || "1000000";
    this.minPriceLabel.innerText = `${this.minPriceInput.value}€`;
    this.maxPriceLabel.innerText = `${this.maxPriceInput.value}€`;
  }

  #registerOnChange() {
    this.minPriceInput.addEventListener("input", () => {
      const value = this.minPriceInput.value;
      this.store.updateState("prix-min", value);
      setUrlFromState(this.store.getState() as State);
      this.minPriceLabel.innerText = `${value}€`;
      this.#renderLabel();
    });

    this.minPriceInput.addEventListener(
      "change",
      this.#switchMinMax.bind(this)
    );

    this.maxPriceInput.addEventListener("input", () => {
      this.store.updateState("prix-max", this.maxPriceInput.value);
      setUrlFromState(this.store.getState() as State);
      this.maxPriceLabel.innerText = `${this.maxPriceInput.value}€`;
      this.#renderLabel();
    });

    this.maxPriceInput.addEventListener(
      "change",
      this.#switchMinMax.bind(this)
    );
  }

  #switchMinMax() {
    const minValue = this.minPriceInput.value;
    const maxValue = this.maxPriceInput.value;
    if (parseInt(minValue) > parseInt(maxValue)) {
      this.store.updateState("prix-min", maxValue);
      this.store.updateState("prix-max", minValue);
      setUrlFromState(this.store.getState() as State);
      this.minPriceLabel.innerText = `${maxValue}€`;
      this.maxPriceLabel.innerText = `${minValue}€`;
      this.#renderLabel();
    }
  }

  #renderLabel() {
    this.label.refresh({
      state: this.store.getState(),
      data: this.data,
    });
  }
}
